import React, { MouseEvent } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
  /** Size of the icon (default: 'small' = 20px) */
  size?: number;
}

/**
 * InfoIcon - Small circular "i" icon for information tooltips
 * 
 * Wraps MUI's InfoOutlined icon for consistency with the codebase.
 * Used next to prices to indicate currency information.
 * 
 * @example
 * ```tsx
 * <InfoIcon size={17} onClick={handleClick} />
 * ```
 */
const InfoIcon = ({ className, onClick, size = 17 }: Props) => {
  return (
    <InfoOutlinedIcon
      className={className}
      onClick={onClick}
      sx={{
        fontSize: size,
        cursor: onClick ? 'pointer' : 'default',
      }}
    />
  );
};

export default InfoIcon;
